import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/customer-redux";
import { Grid, Container, Segment, Header, Divider } from "semantic-ui-react";

import * as models from "../models";
import { loadActionableTasks } from "../actions";

import { actionableTaskButtons } from "./ActionableTaskButtons";

export const ActionableTaskList = () => {
    const actionableTasks = useSelector((state: models.ActionableTasksState) => state.actionableTasks);
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadActionableTasks());
    }, [dispatch]);

    return (
        <Container className="actionable-task-list">
            <Container>
                <Segment basic>
                    <Header as="h1">Outstanding Actions</Header>
                </Segment>
                <Divider hidden />
            </Container>
            <Grid container>
                {actionableTasks.map(task => (
                    <Grid.Row verticalAlign="middle" key={task.id} className="actionable-task-row">
                        <Grid.Column computer={8} mobile={16}>
                            {task.employeeName} <strong>{task.taskDescription}</strong>
                        </Grid.Column>
                        <Grid.Column computer={6} mobile={16}>
                            {task.created.format("DD/MM/YY @ h:mma")}
                        </Grid.Column>
                        <Grid.Column computer={2} mobile={16} className="actionable-task-button">
                            {actionableTaskButtons[task.taskType] && actionableTaskButtons[task.taskType](task)}
                        </Grid.Column>
                    </Grid.Row>
                ))}
            </Grid>
        </Container>
    );
};
